// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"12":"cards","93":"list","263":"widget","276":"grid"}[chunkId] || chunkId) + ".js";
};